module.exports = __webpack_public_path__ + "img/placeholder.97f09265.jpg";